import React, { useState, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCoins,
  faGem,
  faChartLine,
  faShoppingCart,
  faNewspaper,
  faUsers,
  faHammer,
  faMapMarkerAlt,
  faCloud,
  faCube,
  faWallet,
  faUserCircle,
  faSearch,
  faCalendarAlt,
  faTrophy,
  faBookOpen,
  faCog
} from "@fortawesome/free-solid-svg-icons";

// Chart.js
import { Line } from "react-chartjs-2";
import Chart from "chart.js/auto";
import ApexCharts from "react-apexcharts";

export default function RatnavyaHome() {
  const tabs = [
  { icon: "🪙", label: "Latest Price" },
  { icon: "💎", label: "Marketplace" },
  { icon: "🔬", label: "beSure with AI" },
  { icon: "🏭", label: "Metal & Gems MSME" },
  { icon: "⚡", label: "Innovations" },
  { icon: "🪩", label: "Metaverse" },
  { icon: "💰", label: "Portfolio" },
  { icon: "🤝", label: "Forum" },
  { icon: "🧾", label: "Metal & Gems News" },
  { icon: "📖", label: "Monthly Digital Magazine" },
  { icon: "🎓", label: "Skill Certificate" },
  { icon: "💼", label: "Metal & Gems Jobs" },
  { icon: "📱", label: "Digital Earning" },
  { icon: "🤖", label: "AI Counselling" },
  { icon: "👑", label: "My Profile" },
];

  const [activeTab, setActiveTab] = useState("Market");
  const [search, setSearch] = useState("");

  // Dummy market rates
  const rates = useMemo(() => ([
    { id: 'gold', name: 'Gold (24K)', price: 73250, change: -0.35, unit: 'INR/10g' },
    { id: 'silver', name: 'Silver', price: 920, change: 0.7, unit: 'INR/10g' },
    { id: 'platinum', name: 'Platinum', price: 32500, change: -0.1, unit: 'INR/g' },
    { id: 'copper', name: 'Copper', price: 720, change: 0.3, unit: 'INR/kg' },
    { id: 'rare', name: 'Rare Earth Index', price: 18450, change: 1.2, unit: 'Index' },
    { id: 'brass', name: 'Brass', price: 210, change: 0.0, unit: 'INR/kg' }
  ]), []);

  // Dummy marketplace items
  const items = useMemo(() => ([
    { id: 1, title: '916 Gold Necklace', price: 125000, seller: 'Jaipur Jewels', cert: 'BIS', img: null },
    { id: 2, title: 'Ruby Ring - 2.1ct', price: 62000, seller: 'Kolkata Gem Co', cert: 'GIA', img: null },
    { id: 3, title: 'Silver Bulk (100kg)', price: 92000, seller: 'Surat Bullion', cert: 'Assay', img: null },
    { id: 4, title: 'Platinum Wedding Band', price: 82000, seller: 'Mumbai Crafts', cert: 'Lab', img: null }
  ]), []);

  // Dummy stakeholders for profile
  const stakeholders = [
    'Retail Buyer',
    'Jeweller / Artisan',
    'Wholesaler',
    'Assay Lab',
    'Vault & Logistics',
    'Bank / Financier',
    'Government Liaison'
  ];

  // Dummy workers
  const workers = [
    { id: 1, name: 'Ravi - Goldsmith', location: 'Jaipur', skill: 'Goldsmith', rating: 4.6 },
    { id: 2, name: 'Meera - Gem Cutter', location: 'Bengaluru', skill: 'Lapidary', rating: 4.8 },
    { id: 3, name: 'Arjun - Assayer', location: 'Mumbai', skill: 'Assay/Quality', rating: 4.5 }
  ];

  // Dummy portfolio
  const [portfolio, setPortfolio] = useState([
    { id: 'p1', name: '1g Gold (24K)', qty: 5, value: 366250 },
    { id: 'p2', name: 'Ruby (2.1ct)', qty: 1, value: 62000 }
  ]);

  const addToPortfolio = (item) => {
    setPortfolio(p => [...p, { id: `p${Date.now()}`, name: item.title, qty: 1, value: item.price }]);
  };

  const removeFromPortfolio = (id) => setPortfolio(p => p.filter(x => x.id !== id));

  // Chart data for market trends
  const chartData = {
    labels: ['-6d', '-5d', '-4d', '-3d', '-2d', '-1d', 'Today'],
    datasets: [
      {
        label: 'Gold (24K) — INR/10g',
        data: [72700, 73050, 73500, 73400, 73300, 73480, 73250],
        tension: 0.3,
        fill: false,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { display: false },
    },
    scales: {
      x: { grid: { display: false } },
      y: { grid: { borderDash: [4, 6] } }
    }
  };

  const [showHistory, setShowHistory] = useState(false);

  // Dummy candlestick data for 1 week
  const candleData = {
    labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    datasets: [
      {
        label: 'Gold (24K)',
        data: [
          { o: 72800, h: 73200, l: 72500, c: 73000 },
          { o: 73000, h: 73450, l: 72900, c: 73350 },
          { o: 73350, h: 73600, l: 73100, c: 73400 },
          { o: 73400, h: 73700, l: 73250, c: 73550 },
          { o: 73550, h: 73800, l: 73400, c: 73600 },
          { o: 73600, h: 74000, l: 73500, c: 73850 },
          { o: 73850, h: 74200, l: 73700, c: 74000 }
        ],
        borderColor: '#facc15',
        backgroundColor: '#fde68a',
      }
    ]
  };

  const candleOptions = {
    responsive: true,
    plugins: { legend: { display: false } },
    scales: {
      x: { ticks: { color: '#f0f0f0' }, grid: { color: '#444' } },
      y: { ticks: { color: '#f0f0f0' }, grid: { color: '#444', borderDash: [4,6] } }
    }
  };

  // Dummy analysis text
  const analysisText = "Gold has shown a mild bullish trend this week, with gradual increase from Monday to Sunday. Expect potential resistance near ₹74200 and support around ₹72500.";


  // Prediction game state
  const [predValue, setPredValue] = useState('');
  const [predHistory, setPredHistory] = useState([]);
  const submitPrediction = () => {
    if(!predValue) return alert('Please enter a prediction');
    setPredHistory(h => [{ id: Date.now(), value: predValue, when: new Date().toLocaleString() }, ...h]);
    setPredValue('');
    alert('Prediction saved — winners will be announced in Daily Chronicles');
  };

  // Simple search handler for marketplace or workers
  const filteredItems = items.filter(i => i.title.toLowerCase().includes(search.toLowerCase()));
  const filteredWorkers = workers.filter(w => w.name.toLowerCase().includes(search.toLowerCase()) || w.skill.toLowerCase().includes(search.toLowerCase()));

  // Wrapper Component for Candlestick Chart
  function CandlestickChart({ data, options }) {
    const chartRef = React.useRef(null);

    React.useEffect(() => {
      const ctx = chartRef.current.getContext('2d');
      const chartInstance = new Chart(ctx, {
        type: 'candlestick',
        data,
        options
      });
      return () => chartInstance.destroy();
    }, [data, options]);

    return <canvas ref={chartRef} />;
  }

  return (
    <div className="min-h-screen bg-[#0b1020] text-gray-200 font-sans p-4">
      <header className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="rounded-full bg-gradient-to-r from-yellow-400 to-amber-600 w-10 h-10 flex items-center justify-center text-black font-bold">R</div>
          <div>
            <div className="text-xl text-yellow-300">Ratnavya</div>
            <div className="text-m font-semibold">The Digital Ecosystem for Precious Metals, Gems Businesses and People</div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <button className="p-2 rounded-md bg-gray-800" onClick={() => window.open('#settings', '_self')}><FontAwesomeIcon icon={faCog} /></button>
        </div>
      </header>

      {/* Tab list */}
      <div className="mt-1 mb-1 px-3 py-2 border-b border-gray-500">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-2 border-gray-600 place-items-center">
          {tabs.map(({ icon, label }) => (
            <button
              key={label}
              onClick={() => setActiveTab(label)}
              className={`w-full flex items-center justify-center gap-2 px-3 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
                activeTab === label
                  ? "bg-gradient-to-r from-amber-500 to-yellow-400 text-black shadow-md"
                  : "bg-gray-800 text-gray-300 hover:bg-gray-700"
              }`}
            >
              <span className="text-lg">{icon}</span>
              <span>{label}</span>
            </button>
          ))}
        </div>
      </div>


      {/* Search */}
      <div className="mb-4">
        <div className="flex gap-2">
          <input value={search} onChange={(e)=>setSearch(e.target.value)} placeholder={`Search ${activeTab}`} className="flex-1 px-3 py-2 h-10 rounded-md bg-gray-800 text-sm placeholder-gray-400" />
          <button className="w-20 px-3 py-2 rounded-md bg-amber-500 text-black" onClick={() => alert('Search executed') }><FontAwesomeIcon icon={faSearch} /></button>
        </div>
      </div>

      {/* Content area */}
      <main>
        {activeTab === 'Latest Price' && (
          <section>
            <div className="mb-4">
              <Line data={chartData} options={chartOptions} />
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
              {rates.map(r => (
                <div key={r.id} className="bg-gray-800 p-3 rounded-lg">
                  <div className="text-xs text-gray-400">{r.name}</div>
                  <div className="text-xl font-semibold">{r.price.toLocaleString()} <span className="text-sm text-gray-400">{r.unit}</span></div>
                  <div className={`text-sm mt-1 ${r.change >= 0 ? 'text-emerald-400' : 'text-rose-400'}`}>{r.change}%</div>
                  <div className="mt-2 flex gap-2">
                    <button 
                      className="px-3 py-1 rounded-md bg-gray-700 text-sm"
                      onClick={() => setShowHistory(!showHistory)}
                    >
                      History
                    </button>
                    <button className="w-20 px-2 py-1 rounded-md bg-amber-500 text-black text-sm" onClick={() => { setActiveTab('Tools'); alert('Added to watchlist') }}>Watch</button>
                  </div>
                </div>
              ))}
            </div>

            {/* Candlestick Chart (1 week) */}
            {showHistory && (
              <div className="mt-4 bg-gray-800 p-3 rounded-lg">
                <div className="text-sm font-semibold mb-2">1-Week Candlestick Chart</div>

                <ApexCharts
                  type="candlestick"
                  height={350}
                  series={[{
                    data: [
                      { x: 'Mon', y: [72800, 73200, 72500, 73000] },
                      { x: 'Tue', y: [73000, 73450, 72900, 73350] },
                      { x: 'Wed', y: [73350, 73600, 73100, 73400] },
                      { x: 'Thu', y: [73400, 73700, 73250, 73550] },
                      { x: 'Fri', y: [73550, 73800, 73400, 73600] },
                      { x: 'Sat', y: [73600, 74000, 73500, 73850] },
                      { x: 'Sun', y: [73850, 74200, 73700, 74000] }
                    ]
                  }]}
                  options={{
                    chart: {
                      type: 'candlestick',
                      height: 350,
                      background: '#0b1020',
                      toolbar: { show: true },
                    },
                    title: { text: 'Gold Market — 1 Week', style: { color: '#f0f0f0' } },
                    xaxis: {
                      type: 'category',
                      labels: { style: { colors: '#f0f0f0' } }
                    },
                    yaxis: {
                      tooltip: { enabled: true },
                      labels: { style: { colors: '#f0f0f0' } }
                    },
                    tooltip: {
                      theme: 'dark', // <-- Makes tooltip background dark
                      style: {
                        fontSize: '12px',
                        fontFamily: 'Arial, sans-serif',
                        colors: ['#f0f0f0']
                      },
                      x: { 
                        show: true,
                        format: 'dd MMM',
                        formatter: undefined
                      },
                      y: {
                        formatter: val => `₹${val.toLocaleString()}` // Format numbers
                      }
                    },
                    grid: {
                      borderColor: '#333'
                    }
                  }}
                />


                <div className="mt-3 text-gray-200 text-sm">
                  {analysisText || "Gold price remained relatively stable this week with minor fluctuations. Midweek saw slight bullish momentum followed by a consolidation period towards the weekend."}
                </div>
              </div>
            )}

            <div className="mt-4 bg-gray-800 p-3 rounded-lg">
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-sm text-gray-300">Price Prediction Game</div>
                  <div className="text-xs text-gray-400">Predict EOD price for a chance to win prizes</div>
                </div>
                <div className="text-sm text-gray-300">Prize Pool: ₹20,000</div>
              </div>
              <div className="mt-3 flex gap-2">
                <input value={predValue} onChange={(e)=>setPredValue(e.target.value)} className="flex-1 px-3 py-2 rounded-md bg-gray-900 text-sm" placeholder="Enter predicted INR/10g" />
                <button onClick={submitPrediction} className="px-3 py-2 w-20 rounded-md bg-amber-500 text-black">Submit</button>
              </div>

              <div className="mt-3">
                {predHistory.length === 0 ? <div className="text-sm text-gray-400">No predictions yet</div> : (
                  <ul className="space-y-2">
                    {predHistory.map(p => (
                      <li key={p.id} className="text-sm bg-gray-900 p-2 rounded-md">{p.value} — <span className="text-xs text-gray-400">{p.when}</span></li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </section>
        )}

        {activeTab === 'Marketplace' && (
          <section>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
              {filteredItems.map(item => (
                <div key={item.id} className="bg-gray-800 p-3 rounded-lg">
                  <div className="h-28 bg-gray-900 rounded-md mb-2 flex items-center justify-center">Image</div>
                  <div className="font-semibold">{item.title}</div>
                  <div className="text-sm text-gray-400">Seller: {item.seller}</div>
                  <div className="mt-2 flex gap-2">
                    <button className="flex-1 px-2 py-1 w-20 rounded-md bg-gray-700 text-sm" onClick={()=> alert('View details')}>Details</button>
                    <button className="px-2 py-1 w-20 rounded-md bg-amber-500 text-black text-sm" onClick={()=> addToPortfolio(item)}>Buy</button>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-4 bg-gray-800 p-3 rounded-lg">
              <div className="text-sm font-semibold">Wholesale / Unity Bulk Orders</div>
              <div className="text-xs text-gray-400">Request a Quote for bulk orders</div>
              <div className="mt-2 flex gap-2">
                <button onClick={()=> alert('Quote requested — our team will contact you')} className="px-3 py-2 w-30 rounded-md bg-amber-500 text-black">Request Quote</button>
                <button onClick={()=> alert('Upload spec sheet')} className="px-3 py-2 w-30 rounded-md bg-gray-700">Upload Spec</button>
              </div>
            </div>
          </section>
        )}

        {activeTab === 'Forum' && (
          <section>
            <div className="grid grid-cols-2 gap-3">
              <div className="bg-gray-800 p-3 rounded-lg">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-sm">Monthly Magazine</div>
                    <div className="text-xs text-gray-400">Immersive stories, skills & community earnings</div>
                  </div>
                  <div className="text-sm font-semibold">Subscribe</div>
                </div>
                <div className="mt-3">
                  <button onClick={()=> alert('Subscribed to Magazine')} className="px-3 py-2 w-30 rounded-md bg-amber-500 text-black">Subscribe ₹99/mo</button>
                </div>
              </div>

              <div className="bg-gray-800 p-3 rounded-lg">
                <div className="text-sm">Referral Earnings</div>
                <div className="text-xs text-gray-400">Share and earn from your community</div>
                <div className="mt-3">
                  <button onClick={()=> navigator.clipboard.writeText('https://ratnavya.example/ref/XYZ') && alert('Referral link copied')} className="px-3 py-2 w-20 rounded-md bg-gray-700">Copy Link</button>
                </div>
              </div>
            </div>

            <div className="mt-4 bg-gray-800 p-3 rounded-lg">
              <div className="text-sm font-semibold">Leaderboards & Gamification</div>
              <div className="text-xs text-gray-400">Top predictors and contributors</div>
              <div className="mt-2 grid grid-cols-3 gap-2">
                <div className="bg-gray-900 p-2 rounded">1. Meera</div>
                <div className="bg-gray-900 p-2 rounded">2. Ravi</div>
                <div className="bg-gray-900 p-2 rounded">3. Arjun</div>
              </div>
            </div>
          </section>
        )}

        {activeTab === 'Metal & Gems MSME' && (
          <section>
            <div className="grid grid-cols-1 gap-3">
              <div className="bg-gray-800 p-3 rounded-lg">
                <div className="text-sm font-semibold">MSME Zone</div>
                <div className="text-xs text-gray-400">Digital storefronts, finance & procurement</div>
                <div className="mt-2 grid grid-cols-2 gap-2">
                  <button onClick={()=> alert('Open MSME Dashboard')} className="px-3 py-2 w-30 rounded-md bg-amber-500">Open Dashboard</button>
                  <button onClick={()=> alert('Apply for MSME support')} className="px-3 py-2 w-30 rounded-md bg-gray-700">Apply Support</button>
                </div>
              </div>

              <div className="bg-gray-800 p-3 rounded-lg">
                <div className="text-sm font-semibold">Worker Search</div>
                <div className="text-xs text-gray-400">Find skilled artisans nearby</div>
                <div className="mt-2">
                  {filteredWorkers.map(w => (
                    <div key={w.id} className="bg-gray-900 p-2 rounded mb-2">
                      <div className="flex items-center justify-between">
                        <div>
                          <div className="font-semibold">{w.name}</div>
                          <div className="text-xs text-gray-400">{w.skill} • {w.location}</div>
                        </div>
                        <div className="text-sm">⭐ {w.rating}</div>
                      </div>
                      <div className="mt-2 flex gap-2">
                        <button onClick={()=> alert('Chat with worker')} className="flex-1 px-2 py-1 w-12 rounded-md bg-gray-700">Chat</button>
                        <button onClick={()=> alert('Book worker')} className="px-2 py-1 w-12 rounded-md bg-amber-500">Book</button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>
        )}

        {activeTab === 'Innovations' && (
          <section>
            <div className="grid grid-cols-1 gap-3">
              <div className="bg-gray-800 p-3 rounded-lg">
                <div className="text-sm font-semibold">RCA & Analytics</div>
                <div className="text-xs text-gray-400">Root Cause Analysis tools for quality & supply</div>
                <div className="mt-2">
                  <button onClick={()=> alert('Open RCA module')} className="px-3 py-2 w-20 rounded-md bg-amber-500">Open RCA</button>
                </div>
              </div>

              <div className="bg-gray-800 p-3 rounded-lg">
                <div className="text-sm font-semibold">Immersive Digital Books</div>
                <div className="text-xs text-gray-400">Skills, productivity, LnD modules</div>
                <div className="mt-2 grid grid-cols-2 gap-2">
                  <button onClick={()=> alert('Open Book: Goldsmithing 101')} className="px-3 py-2 w-30 rounded-md bg-gray-700">Goldsmithing 101</button>
                  <button onClick={()=> alert('Open Book: Gem Certification')} className="px-3 py-2 w-30 rounded-md bg-gray-700">Gem Certification</button>
                </div>
              </div>
            </div>
          </section>
        )}

        {activeTab === 'Metaverse' && (
          <section>
            <div className="bg-gray-800 p-3 rounded-lg">
              <div className="text-sm font-semibold">Digital Twin Showroom</div>
              <div className="text-xs text-gray-400">AR try-on, virtual trade fair</div>
              <div className="mt-2 flex gap-2">
                <button onClick={()=> alert('Enter Metaverse')} className="px-3 py-2 w-16 rounded-md bg-amber-500">Enter</button>
                <button onClick={()=> alert('Upload 3D model')} className="px-3 py-2 w-16 rounded-md bg-gray-700">Upload</button>
              </div>
            </div>
          </section>
        )}

        {activeTab === 'Portfolio' && (
          <section>
            <div className="bg-gray-800 p-3 rounded-lg">
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-sm font-semibold">My Investment Portfolio</div>
                  <div className="text-xs text-gray-400">Track holdings, valuation, vault status</div>
                </div>
                <div className="text-sm">Net Value: ₹{portfolio.reduce((s,i)=>s+i.value,0).toLocaleString()}</div>
              </div>

              <div className="mt-3 space-y-2">
                {portfolio.map(p => (
                  <div key={p.id} className="bg-gray-900 p-2 rounded flex items-center justify-between">
                    <div>
                      <div className="font-semibold">{p.name}</div>
                      <div className="text-xs text-gray-400">Qty: {p.qty}</div>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="font-semibold">₹{p.value.toLocaleString()}</div>
                      <button onClick={()=> removeFromPortfolio(p.id)} className="px-2 py-1 w-12 rounded-md bg-rose-600 text-sm">Remove</button>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="mt-3 bg-gray-800 p-3 rounded-lg">
              <button onClick={()=> alert('Open Vault options')} className="px-3 py-2 w-40 rounded-md bg-amber-500">Secure Vault & Insurance</button>
            </div>
          </section>
        )}

        {activeTab === 'News' && (
          <section>
            <div className="space-y-3">
              <div className="bg-gray-800 p-3 rounded-lg">
                <div className="text-sm font-semibold">Market News — Shorts</div>
                <div className="text-xs text-gray-400">Latest headlines & quick reads</div>
                <ul className="mt-2 space-y-2">
                  <li className="bg-gray-900 p-2 rounded">Gold demand rises in Q3 — jewellers report higher footfall</li>
                  <li className="bg-gray-900 p-2 rounded">Gem certification standards updated — labs issue guidance</li>
                  <li className="bg-gray-900 p-2 rounded">Rare earths gain as tech demand ramps</li>
                </ul>
              </div>

              <div className="bg-gray-800 p-3 rounded-lg">
                <div className="text-sm font-semibold">Daily Chronicles / Diary</div>
                <div className="text-xs text-gray-400">Your private notes on market moves and ideas</div>
                <div className="mt-2">
                  <textarea placeholder="Write your daily note..." className="w-full h-28 bg-gray-900 p-2 rounded text-sm" />
                  <div className="mt-2 flex gap-2">
                    <button onClick={()=> alert('Saved note')} className="px-3 py-2 w-12 rounded-md bg-amber-500">Save</button>
                    <button onClick={()=> alert('Cleared')} className="px-3 py-2 w-12 rounded-md bg-gray-700">Clear</button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {activeTab === 'AI Counselling' && (
          <section>
            <div className="grid grid-cols-2 gap-3">
              <div className="bg-gray-800 p-3 rounded-lg">
                <div className="text-sm font-semibold">AI Counselling</div>
                <div className="text-xs text-gray-400">Advice for self, staff & family</div>
                <div className="mt-2">
                  <button onClick={()=> alert('Open AI Counselling chat')} className="px-3 py-2 w-20 rounded-md bg-amber-500">Open Chat</button>
                </div>
              </div>

              <div className="bg-gray-800 p-3 rounded-lg">
                <div className="text-sm font-semibold">Online Consults</div>
                <div className="text-xs text-gray-400">Book gemologist or valuation expert</div>
                <div className="mt-2">
                  <button onClick={()=> alert('Booked consult — expert will contact you')} className="px-3 py-2 w-30 rounded-md bg-gray-700">Book Expert</button>
                </div>
              </div>
            </div>
          </section>
        )}

        {activeTab === 'My Profile' && (
          <section>
            <div className="bg-gray-800 p-3 rounded-lg mb-3">
              <div className="flex items-center gap-3">
                <div className="w-14 h-14 bg-gray-900 rounded-full flex items-center justify-center text-2xl">U</div>
                <div>
                  <div className="font-semibold">Sanjeev Kumar</div>
                  <div className="text-xs text-gray-400">Role: Platform Admin</div>
                </div>
              </div>

              <div className="mt-3 grid grid-cols-2 gap-2">
                {['Edit Profile','Security','Notifications','Payments'].map(p => (
                  <button key={p} className="px-3 py-2 rounded-md bg-gray-700" onClick={()=> alert(p)}>{p}</button>
                ))}
              </div>
            </div>

            <div className="bg-gray-800 p-3 rounded-lg">
              <div className="text-sm font-semibold">Stakeholders</div>
              <div className="text-xs text-gray-400">Tap a stakeholder to view role-specific actions</div>
              <div className="mt-3 grid grid-cols-2 gap-2">
                {stakeholders.map(s => (
                  <button key={s} className="px-3 py-2 rounded-md bg-gray-900 text-left" onClick={()=> alert(`${s} actions opened`)}>{s}</button>
                ))}
              </div>
            </div>
          </section>
        )}

      </main>

      <footer className="mt-6 text-center text-xs text-gray-500">© Ratnavya • Powered by Think5Whys</footer>
    </div>
  );
}
